// extracted by mini-css-extract-plugin
export default {"table":"SuperBatchModulesTable_table__2oP2J"};